<div *adaptLoading="!person"
     (mouseenter)="popoverInitialised = true"
     #mentionPerson
     class="d-inline-block">
    <span spellcheck="false"
          class="adapt-mention-box"
          data-mention-person-id="personId">&#64;{{person!.fullName}}</span>
    <dx-popover *ngIf="popoverInitialised"
                [target]="mentionPerson"
                showEvent="dxpointerenter"
                [hideEvent]="{ name: 'dxpointerleave', delay: 300 }"
                [(visible)]="popoverVisible"
                [minWidth]="300"
                [position]="popoverPosition"
                (onContentReady)="onPopoverContentReady($event)"
                (onShowing)="popoverCancelHiding = false"
                (onHiding)="onPopoverHiding($event)">
        <adapt-link-person-contents [person]="person"></adapt-link-person-contents>
    </dx-popover>
</div>
